import React from 'react';
import { motion } from 'framer-motion';
import { RepHeader } from '../RepHeader';
import { repConfig } from '../../../config';
import { CheckCircle2, MessageSquare, ShieldCheck } from '../../ui/Icons';
import { Button } from '../../ui/Button';

export function StepConfirm({ data }) {
  return (
    <div className="w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-4 md:space-y-10 py-4 md:py-12 overflow-y-auto max-h-full">
      {/* Success Animation */}
      <motion.div
        initial={{ scale: 0, rotate: -45 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", damping: 15, stiffness: 200, delay: 0.2 }}
        className="w-16 h-16 md:w-24 md:h-24 bg-green-500/20 rounded-full flex items-center justify-center text-green-400 shrink-0"
      >
        <CheckCircle2 size={32} className="md:w-12 md:h-12" />
      </motion.div>

      {/* Main Confirmation Message */}
      <div className="space-y-4 md:space-y-6">
        <h1 className="font-heading text-2xl md:text-5xl font-bold px-2">
          You're all set, {data.firstName}!
        </h1>
        <div className="flex flex-col items-center gap-4">
          <p className="text-sm md:text-xl text-gray-400 max-w-lg mx-auto px-4 leading-relaxed">
            Your vehicle search preferences have been securely sent to {repConfig.name}.
          </p>
          
          <div className="flex items-center gap-2 text-emerald-400 font-bold text-xs md:text-sm bg-emerald-400/10 px-4 py-2 rounded-full border border-emerald-400/20">
            <ShieldCheck size={16} />
            Submission Successful
          </div>
        </div>
      </div>

      {/* Representative Info */}
      <div className="w-full px-2">
        <RepHeader variant="large" />
      </div>

      {/* Next Steps / Contact CTA */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 w-full space-y-4 md:space-y-6 mb-4">
        <div className="space-y-2">
          <h4 className="font-semibold text-base md:text-xl">What happens next?</h4>
          <p className="text-gray-400 text-[12px] md:text-base">
            {repConfig.name} will personally review your criteria and reach out via {data.phone} with your custom vehicle options.
          </p>
        </div>
        
        <div className="pt-2">
          <a
            href={`sms:${repConfig.phoneClean}?body=Hi ${repConfig.name}, I just completed your vehicle search quiz online!`}
            className="block w-full"
          >
            <Button variant="secondary" className="w-full bg-white/10 hover:bg-white/20 h-12 md:h-16 text-sm md:text-lg">
              <MessageSquare size={18} className="md:w-6 md:h-6" />
              Text {repConfig.name.split(' ')[0]} Directly
            </Button>
          </a>
          <p className="text-[10px] text-gray-500 mt-3 italic">
            Usually responds within 30 minutes during business hours.
          </p>
        </div>
      </div>
    </div>
  );
}